<template>
<div>
  <!-- <div>

    <el-input v-model="todoName" autocomplete="off"></el-input>


    <h1>Todos</h1>
    <ul>
      <li v-for="todo of todos" :key="todo.id">
        {{ todo.name }}
      </li>
    </ul>
  </div> -->
  <VueDragResize
  :isActive="false"
  v-for="(item,index) in this.ScenarioDisplay"
  :x="dateToCoords.x"
  :w="dateToCoords.w"
  :h='(item.h)*$store.state.rowHeight'
  :y='(item.y)*$store.state.rowHeight'
  :z='item.z'
  axis="x"
  :isResizable="false"
  :isDraggable="false"
  @activated=""
  @deactivated=""
  @clicked=""
  :snapToGrid="true"
  :gridX="$store.state.colWidth"
  :gridY="$store.state.rowHeight"
  :style="{'background-color': blockColor(item.z),
            'color': '#003950',
            'position':'absolute',
            'border-radius': '5px',
            'padding-left':'0',
            'padding-top': '0',
            'padding-bottom': '0',
            'padding-right': '0',
            'margin': '0px auto',
            'border': '1px solid #00395075'
            }"
  >


    <div class="blocktextsub">
      <div class="containersb">

        <div class="flex-itemsb2">
          <div class="containersb">

            <div class="flex-itemsb" v-if="item.z==1">

            </div>
            <div class="flex-itemsbgroup" v-if="item.z==1">
              <el-button-group>
                <el-button  size="mini" type="primary" icon="el-icon-s-unfold" circle @click="expandSubBlock()" circle></el-button>
                <el-button  size="mini" type="primary" icon="el-icon-setting" circle @click="ScenarioSetSettings(item)" circle></el-button>
                <el-button  size="mini" type="primary" icon="el-icon-refresh" circle @click="ScenarioRefresh(item.id)" circle></el-button>
                <el-button  size="mini" type="primary" icon="el-icon-plus" circle @click="addTodo()" circle></el-button>

                <el-button  size="mini" type="primary" icon="el-icon-delete" circle></el-button>
              </el-button-group>
            </div>
            <div class="flex-itemsb" v-if="item.z==2">
              <el-button  size="mini" icon="el-icon-plus" circle @click="expandSubBlock()" circle></el-button>

            </div>


          </div>
        </div>

        <div v-if="item.z==1" class="TitleBlockAlt">
          {{item.name}}-y-{{item.y}}-h-{{item.h}}-m-{{item.hasOwnProperty("CanvasGroups")}}-z-{{item.z}}

            <!-- <CanvasInlineTitle :textin="this.blocks.name"></CanvasInlineTitle> -->
        </div>
        <div v-if="item.z==2" class="TitleBlockAlt3">
          {{item.name}}<!-- {{item.name}}-y-{{item.y}}-h-{{item.h}}-m-{{item.hasOwnProperty("CanvasGroups")}}-z-{{item.z}} -->
            <!-- <CanvasInlineTitle :textin="this.blocks.name"></CanvasInlineTitle> -->
        </div>

      </div>
    </div>

    <CanvasOmniBlockGrouping
      :OmniBlocksInput="item"
      :scenarioIn="scenarioIn.id"
      :timelinezoomlevel="timelinezoomlevel"
      :parentx="dateToCoords.x"


      >


    </CanvasOmniBlockGrouping>



    <CanvasOmniBlock

         v-if='item.type=="Models"'
         v-for="(model, modelindex) in item.CanvasGroups"
         :yoffset="item.subys[modelindex]"
         :zoffset="5"
         :scenarioset="scenarioIn.id"
         :headerOnly="true"
         :parentx="dateToCoords.x"
         :blocks="CGsforCanvasOmniBlock(model)"
         :timelinezoomlevel="timelinezoomlevel"
    >

    </CanvasOmniBlock>


    <!-- <CanvasOmniBlock

         v-if='item.type=="Computed"'
         v-for="(model, modelindex) in item.CompComponents"
         :yoffset="item.subys[modelindex]"
         :zoffset="5"
         :scenarioset="scenarioIn.id"
         :headerOnly="true"
         :parentx="dateToCoords.x"
         :blocks="ComputedforCanvasOmniBlock(model)"
         :timelinezoomlevel="timelinezoomlevel"

    >

    </CanvasOmniBlock> -->

  </VueDragResize>

  <el-dialog
    title="Edit Set"
    :visible.sync="SetOptionsDialog"
    width="60%"
    :modal=false
    :before-close="handleSetOptionsDialogClose">
    {{this.ScenarioSetSettings}}
    <CanvasScenarioSettings :scenarioSetIn='this.ScenarioSetSettings'></CanvasScenarioSettings>


    <span slot="footer" class="dialog-footer">
      <el-button @click="SetOptionsDialog = false">Cancel</el-button>
      <el-button type="primary" @click="handleSetOptionsDialogClose()">Set Options</el-button>
    </span>
  </el-dialog>


</div>


</template>
<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #003950;
    color: #ffffff;
  }
  .bg-purple {
    background: #00395096;
  }
  .bg-purple-light {
    background: #00395052;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

</style>
<script>
import CanvasOmniBlock from '@/components/Canvas/Canvas-Omni-Block.vue'
import CanvasScenarioSettings from '@/components/Canvas/Canvas-Scenario-Settings.vue'
import CanvasOmniBlockGrouping from '@/components/Canvas/Canvas-Omni-Block-Grouping.vue'
import axios from "axios";
const baseURL = "http://localhost:3333/todos";


export default {
  name: 'CanvasScenarioBlock',
  components: {
    CanvasOmniBlock, CanvasScenarioSettings, CanvasOmniBlockGrouping

  },
  props: {
    scenarioIn: {

    },
    CanvasGroupsIn: {

    },
    timelinezoomlevel: {

    }
  },
  data: function () {
    return {
        todos: [],
        todoName: "",
        SetOptionsDialog: false,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        ScenarioSetSettingsIn: [],
        SetInputOutput: [],
        activeName: [2],
        options: [{
          label: 'Popular cities',
          options: [{
            value: 'Shanghai',
            label: 'Shanghai'
          }, {
            value: 'Beijing',
            label: 'Beijing'
          }]
        }, {
          label: 'City name',
          options: [{
            value: 'Chengdu',
            label: 'Chengdu'
          }, {
            value: 'Shenzhen',
            label: 'Shenzhen'
          }, {
            value: 'Guangzhou',
            label: 'Guangzhou'
          }, {
            value: 'Dalian',
            label: 'Dalian'
          }]
        }],
        value: ''
    }
  },
  async created() {
    try {
      const res = await axios.get(baseURL);

      this.todos = res.data;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    testButton() {
      console.log("testButton")
    },
    async addTodo() {
      console.log("addTodo()")
      try {
        const res = await axios.post(baseURL, { name: this.todoName });

        this.todos = [...this.todos, res.data];

        this.todoName = "";
      } catch (e) {
        console.error(e);
      }
    },

    handleSetOptionsDialogClose(){
      console.log("handleSetOptionsDialogClose",this.ScenarioSetSettings)

      //update store
      this.$store.dispatch('setScenarioSetSettings',[this.scenarioIn,this.ScenarioSetSettings])
    },
    CGsforCanvasOmniBlock(cg){

      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))
      var index0 = clone.findIndex((v) => {
        return v.id==cg;
      });

      return clone[index0]

    },

    ComputedforCanvasOmniBlock(model){
      console.log("got inside ComputedforCanvasOmniBlock",model)
      //console.log(this.$store.dispatch('ComputedCanvasGroup',[model,this.timelinezoomlevel]))
      var ObReturn = this.$store.dispatch('ComputedCanvasGroup',[model,this.timelinezoomlevel])

      //console.log("ObReturn",ObReturn)

      return ObReturn

    },


    blockColor (z) {

      if(z==1){
        return '#00395029';
      // }else if (z==2) {
      //   return '#67c23a40';
      }else if (z==2) {
        return '#ffffff95';
      }else{
        return '#67c23a40';
      }

    },
    findDateIndex(DateIndex,DateToFind) {

      var index = DateIndex.findIndex((v) => {
        return new Date(v).getTime()===new Date(DateToFind).getTime();
      });

        return index;
    },
    ScenarioSetSettings(ScenIn){
      console.log("ScenarioSetSettings",ScenIn)
      this.ScenarioSetSettings=ScenIn

      this.SetOptionsDialog=true

    },
    ScenarioRefresh(){
      console.log("ScenarioRefresh")

      this.$store.dispatch('UpdateCanvasGroups',[this.timelinezoomlevel])


    },
    ScenarioSetMode(id,mode) {
      console.log("ScenarioSetMode",id,mode)

    },
    ScenarioGetMode(id) {
      console.log("ScenarioGetMode",id)

      var index = this.SetInputOutput.findIndex((v) => {
        return v.id==id;
      });

      return this.SetInputOutput[index].mode
    },
    ScenarioWidth(scenario, CanvasGroups) {

      var clone=JSON.parse(JSON.stringify(CanvasGroups))

      //var scenario=this.scenarioIn;
      var startDates = [];
      var endDates = [];

      for(let ScenSets=0; ScenSets<scenario.sets.length; ScenSets++){
          this.SetInputOutput.push({id:scenario.sets[ScenSets].id,mode:'input'})
      }

      console.log("scenario",scenario.sets)
      for(let s=0; s<scenario.sets.length; s++){

        for(let ss=0; ss<scenario.sets[s].subsets.length; ss++){
          for(let cg=0; cg<scenario.sets[s].subsets[ss].CanvasGroups.length; cg++){

            var index0 = clone.findIndex((v) => {
              return v.id==scenario.sets[s].subsets[ss].CanvasGroups[cg];
            });
            var sdate = clone[index0].daterange[0]
            var edate = clone[index0].daterange[1]

            startDates.push(new Date(sdate.year,sdate.month-1,sdate.day))
            endDates.push(new Date(edate.year,edate.month-1,edate.day))

          }
        }

      }
      var scenarioSdate = new Date(Math.min.apply(null,startDates))
      var scenarioEdate = new Date(Math.max.apply(null,endDates))

      console.log("min start Date",new Date(Math.min.apply(null,startDates)))
      return [scenarioSdate,scenarioEdate]

    }


  },
  watch: {
    CanvasGroupsIn: function() {
      console.log("CanvasGroupsIn updated")

    }

  },
  computed: {

    dateToCoords () {
      //console.log("this.daterange",this.daterange)

      var clone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      var clone1 = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));
      //var cgclone = JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))

      //need to find nearest date
      //if day is < mid month, set day to 1 for current month, else, move to next month and set day==1
      //var tdaterange = this.blocks.daterange
      var CanvasGroups = this.CanvasGroupsIn

      var SceanrioXs = this.ScenarioWidth(this.scenarioIn,this.CanvasGroupsIn)

      var tdaterange = [{year:SceanrioXs[0].getFullYear(),month:SceanrioXs[0].getMonth()+1,day:SceanrioXs[0].getDate()},
                        {year:SceanrioXs[1].getFullYear(),month:SceanrioXs[1].getMonth()+1,day:SceanrioXs[1].getDate()}]

      if(this.timelinezoomlevel=="days"){
        //console.log("looking for DateIndex")

        var startDate =new Date(tdaterange[0].year,(tdaterange[0].month-1),tdaterange[0].day)
        var endDate =new Date(tdaterange[1].year,(tdaterange[1].month-1),tdaterange[1].day)


        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)

        var foundIndex2 = this.findDateIndex(clone,endDate)
        //console.log("startDate",endDate,"@ index", foundIndex2)

        var x = foundIndex*this.$store.state.colWidth
        var w = (foundIndex2-foundIndex)*this.$store.state.colWidth

      }else{
        //console.log("looking for MonthIndex CSB")
        //console.log("clone1",clone1)

        if(tdaterange[0].day<15){
          var startDate =new Date(tdaterange[0].year,(tdaterange[0].month)-1,1)

        }else{
          var startDate =new Date(tdaterange[0].year,(tdaterange[0].month),1)

        }
        if(tdaterange[1].day<15){
          var endDate =new Date(tdaterange[1].year,(tdaterange[1].month-1),1)

        }else{
          var endDate =new Date(tdaterange[1].year,(tdaterange[1].month),1)

        }

        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone1,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)

        var foundIndex2 = this.findDateIndex(clone1,endDate)
        //console.log("startDate",endDate,"@ index", foundIndex2)

        var x = foundIndex*this.$store.state.colWidth
        var w = (foundIndex2-foundIndex)*this.$store.state.colWidth
      }

      return {x:x,w:w};


      //return this.daterange;

    },

    ScenarioX () {

      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))

      var scenario=this.scenarioIn;
      var startDates = [];
      var endDates = [];

      for(let ScenSets=0; ScenSets<scenario.sets.length; ScenSets++){
          this.SetInputOutput.push({id:scenario.sets[ScenSets].id,mode:'input'})
      }

      console.log("scenario",scenario.sets)
      for(let s=0; s<scenario.sets.length; s++){

        for(let ss=0; ss<scenario.sets[s].subsets.length; ss++){
          for(let cg=0; cg<scenario.sets[s].subsets[ss].CanvasGroups.length; cg++){

            var index0 = clone.findIndex((v) => {
              return v.id==scenario.sets[s].subsets[ss].CanvasGroups[cg];
            });
            var sdate = clone[index0].daterange[0]
            var edate = clone[index0].daterange[1]

            startDates.push(new Date(sdate.year,sdate.month-1,sdate.day))
            endDates.push(new Date(edate.year,edate.month-1,edate.day))

          }
        }




        //min start date

        //max end date

      }
      var scenarioSdate = new Date(Math.min.apply(null,startDates))
      var scenarioEdate = new Date(Math.min.apply(null,endDates))

      console.log("min start Date",new Date(Math.min.apply(null,startDates)))
      return [scenarioSdate,scenarioEdate]

    },

    ScenarioDisplay () {
      console.log("ScenarioDisplay")
      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))

      var scenario=this.scenarioIn;
      var scenariodisp=JSON.parse(JSON.stringify(this.scenarioIn));

      let rows =[3];
      let y=[1];
      let z=[];
      let h=0;
      var flatcontainer = [];

      var allGroups=true;


      if(allGroups){

        //if set to display all groups, expand scenario.sets to include all relevant levels
        for(let s=0; s<scenario.sets.length; s++){
          console.log("----s",s)
          for(let ss=0; ss<scenario.sets[s].subsets.length; ss++){
            console.log("ss",ss)

            var expandedCGs =[]

            for(let cg=0; cg<scenario.sets[s].subsets[ss].CanvasGroups.length; cg++){
              console.log("cg",cg)

              for(let c=0; c<5; c++){
                expandedCGs.push(scenario.sets[s].subsets[ss].CanvasGroups[cg])
              }

            }
            console.log("expandedCGs",expandedCGs)

            scenariodisp.sets[s].subsets[ss].CanvasGroups = expandedCGs

          }

        }

      }else{

      }






      //iterate through sets in the scenario
      for(let s=0; s<scenariodisp.sets.length; s++){
        console.log("ScenarioDisplay s",s)

        y.push(y[y.length-1]+3)
        scenariodisp.sets[s].y=y[y.length-1]
        scenariodisp.sets[s].z=1

        //iterate through subsets in the set
        for(let ss=0; ss<scenariodisp.sets[s].subsets.length; ss++){
          console.log("ScenarioDisplay ss",scenariodisp.sets[s].subsets[ss].id)

          y.push(y[y.length-1]+2)

          scenariodisp.sets[s].subsets[ss].y=y[y.length-1]
          scenariodisp.sets[s].subsets[ss].z=2
          var subys = [2]
          //iterate through CanvasGroups in the subset
          for(let cg=0; cg<scenariodisp.sets[s].subsets[ss].CanvasGroups.length; cg++){
            y.push(y[y.length-1]+6)
            subys.push(1+(cg+1)*6)
          }
          y.push(y[y.length-1]+1)
          scenariodisp.sets[s].subsets[ss].subys=subys
          scenariodisp.sets[s].subsets[ss].h=y[y.length-1]-scenariodisp.sets[s].subsets[ss].y

          //add additional container layer
          var addcontainer = JSON.parse(JSON.stringify(scenariodisp.sets[s].subsets[ss]))
          addcontainer.y=addcontainer.y+1
          addcontainer.h=addcontainer.h-1
          addcontainer.z=3
          addcontainer.name="nicebox"
          delete addcontainer.CanvasGroups
          //flatcontainer.push(addcontainer)


          flatcontainer.push(scenariodisp.sets[s].subsets[ss])


        }
        scenariodisp.sets[s].h=y[y.length-1]-scenariodisp.sets[s].y
        flatcontainer.push(scenariodisp.sets[s])
      }

      console.log(flatcontainer)
      return flatcontainer;

    }

  }


}
</script>
